import type {
  OutreachDraftResponse,
  OutreachStibeeListResponse,
  OutreachTestSendRequest,
  SaveOutreachDraftRequest,
} from '@aegislab/shared';
import { apiClient } from '@/shared/api';

/** 서버 계약은 shared 가 든다 — 프론트에 사본을 세우지 않는다(apiContractCopyGuard). */
export type OutreachDraftRow = OutreachDraftResponse;

const base = (scenarioId: string) => `/campaigns/${scenarioId}/outreach-draft`;

/** 내 초안 되읽기. 아직 쓴 적이 없으면 `null` 이다 — 오류가 아니다. */
export const fetchOutreachDraft = async (
  scenarioId: string,
  country: string
): Promise<OutreachDraftRow | null> => {
  const response = await apiClient.get<OutreachDraftRow | null>(`${base(scenarioId)}/${country}`);
  return response.data ?? null;
};

export const saveOutreachDraft = async (
  scenarioId: string,
  body: SaveOutreachDraftRequest
): Promise<OutreachDraftRow> => {
  const response = await apiClient.put<OutreachDraftRow>(base(scenarioId), body);
  return response.data;
};

/**
 * 작성기가 고르는 스티비 주소록 — AXIOM 이 시드로 든 것(fact #2956). 번호가 키이고 이름은
 * 표시용이며, 보내는 사람은 주소록의 인증 발신자 안에서만 고른다.
 */
export const fetchStibeeLists = async (scenarioId: string): Promise<OutreachStibeeListResponse> => {
  const response = await apiClient.get<OutreachStibeeListResponse>(
    `/campaigns/${scenarioId}/outreach-rounds/stibee-lists`
  );
  return response.data;
};

/** 검증된 내부 주소로 `[TEST]` 한 통. 후보에게는 아무것도 나가지 않는다. */
export const sendOutreachTestMail = async (
  scenarioId: string,
  country: string,
  body: OutreachTestSendRequest
): Promise<{ sentAt: string }> => {
  const response = await apiClient.post<{ sentAt: string }>(
    `${base(scenarioId)}/${country}/test`,
    body
  );
  return response.data;
};
